import { LandingPagesOccupationsByKey, LandingPagesGPTData, SEO_URL_LANDING_PAGE_PREFIX } from "@authory-packages/seo-static-data";
import { getUserExamples } from "../../api/examples";
import { ExampleUserListQueryParams, ExampleUserListResponse } from "@authory-packages/core";
import { HomepagePageLayout } from "../../pagelayouts/homepage";
import { APPLICATION_ROUTES } from "../../shared-logic/routes";

const occupations = LandingPagesOccupationsByKey();

export interface LandingPageJobPageProps {
    jobData: LandingPagesGPTData;
    userListReponse: ExampleUserListResponse;
}

const LandingPageJobPage = ({ jobData, userListReponse }: LandingPageJobPageProps) => {
    return (
        <HomepagePageLayout
            data={jobData}
            usersList={userListReponse}
            isLandingPage
            canonical={`${process.env.NEXT_PUBLIC_FRONTEND_URL}${APPLICATION_ROUTES.USE_CASES}/${SEO_URL_LANDING_PAGE_PREFIX}${jobData.key}`}
        />
    );
};

export async function getStaticPaths() {
    let paths: any[] = [];

    if (process.env.EXAMPLES_PAGES_PIPELINE) {
        paths = Object.keys(occupations)
            .map((key: string) => occupations[key])
            .map((occ) => ({
                params: { job: `${SEO_URL_LANDING_PAGE_PREFIX}${occ.key}` }
            }));
    }

    return { paths, fallback: process.env.NODE_ENV === "development" ? "blocking" : false };
}

export async function getStaticProps(ctx: any) {
    const job = (ctx.params.job as string).replace(SEO_URL_LANDING_PAGE_PREFIX, "");

    const params = new ExampleUserListQueryParams();
    params.key = job;

    const jobData = occupations[job];

    // Get the author
    let userListReponse: ExampleUserListResponse;

    try {
        userListReponse = await getUserExamples(params);
    } catch (e) {}

    return {
        props: {
            userListReponse: userListReponse!,
            jobData
        }
    };
}

export default LandingPageJobPage;
